import { axiosInstance } from "src/axios-instance";

const notificationsRoot = "notifications";
const notificationsServices = {
  getNotifications: () => axiosInstance.get(notificationsRoot),
  createNotification: (data) =>
    axiosInstance.postForm(`${notificationsRoot}/store`, data),
  updateNotification: ( data) =>
    axiosInstance.postForm(`${notificationsRoot}/update/${data.id}`, data),

  deleteNotification: (id) =>
    axiosInstance.delete(`${notificationsRoot}/delete/${id}`),
  getNotification: (id) => axiosInstance.get(`${notificationsRoot}/show/${id}`),
  PublishNotification: (id, target) =>
    axiosInstance.post(`${notificationsRoot}/publish/${id}`, { target }),
  UnPublishNotification: (id) =>
    axiosInstance.put(`${notificationsRoot}/unpublish/${id}`),
};

export default notificationsServices;
